import React from "react";
import { GiftIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { bonuses } from "../../data/landing";
export function Bonuses() {
  const total = bonuses.reduce((s, b) => s + b.value, 0);
  return <section className="bg-white px-4 py-16 sm:py-20" data-id="element-115" data-mp="18julhsi7o7kh">
      <div className="mx-auto max-w-5xl" data-id="element-116" data-mp="18l5q1ujhdjcn">
        <SectionHeading label="Included free today" title={<>
              5 exclusive bonuses <em className="italic text-brand-600" data-id="element-118" data-mp="20aikaxwex0uz">at no extra cost</em>
            </>} data-id="element-117" data-mp="259lflqmlbspr" />

        <div className="mt-10 space-y-14 sm:space-y-16" data-id="element-119" data-mp="1w8428g0ki54r">
          {bonuses.map((b, i) => <article key={b.number} className="grid items-center gap-6 md:grid-cols-2 md:gap-10" data-id="element-120" data-mp="1ravhc7o1bmzt" data-mpi={i}>
              <img src={b.image} alt={`Bonus ${b.number}: ${b.title}`} className={`-mx-4 w-[calc(100%+2rem)] max-w-none sm:mx-0 sm:w-full ${i % 2 === 1 ? "md:order-2" : ""}`} data-id="element-121" data-mp="ku9z0zmums6g" />
              <div data-id="element-122" data-mp="1eug7ugb3qkr7">
                <div className="flex flex-wrap items-center gap-2" data-id="element-123" data-mp="1eru0ago7o58z">
                  <span className="rounded-full bg-brand-700 px-3 py-1 text-xs font-extrabold uppercase text-white" data-id="element-124" data-mp="1js841mis4t17">
                    Bonus #{b.number}
                  </span>
                  <span className="text-sm font-semibold text-muted" data-id="element-125" data-mp="1ar0bzm6uwofk">
                    Value: <span className="line-through" data-id="element-126" data-mp="w2njx0aw3pqc">${b.value}</span>{" "}
                    <span className="font-extrabold text-cta-dark" data-id="element-127" data-mp="10tvptmd0gsyr">FREE today</span>
                  </span>
                </div>
                <h3 className="mt-3 font-serif text-2xl font-extrabold leading-tight text-ink sm:text-3xl" data-id="element-128" data-mp="n3a65vfqgezt">{b.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-muted" data-id="element-129" data-mp="r4vrm56c21lm">{b.text}</p>
                <p className="mt-3 font-semibold text-ink" data-id="element-130" data-mp="d5cib91sck7q">{b.note}</p>
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-14 flex max-w-xl flex-col items-center rounded-3xl bg-brand-800 px-5 py-7 text-center text-white" data-id="element-131" data-mp="i2mjflyjekbe">
          <GiftIcon className="h-8 w-8 text-brand-200" aria-hidden="true" data-id="element-132" data-mp="2f23hkvy65ruz" />
          <p className="mt-3 text-lg font-semibold text-brand-100" data-id="element-133" data-mp="2f00ilmf1goe4">
            Total bonus value: <span className="line-through" data-id="element-134" data-mp="2ay5j8ngo4l2z">${total}</span>
          </p>
          <p className="mt-1 font-serif text-3xl font-black" data-id="element-135" data-mp="262gfe7xm8i0v">You get all 5 free today</p>
        </div>

        <CTAButton className="mt-8" label="I want the system + all 5 bonuses" data-id="element-136" data-mp="32q4ok0fp908a" />
      </div>
    </section>;
}